// extracted by mini-css-extract-plugin
export default {"allCourseDescriptionWrapper":"allCourseDesc_allCourseDescriptionWrapper__9Btvn"};